<template>
    <div class="empresa container">
        <div class="row">
            <div class="empresa-chamada col-md-12">
                    <h3>conheça nossa</h3>
                    <h2>história</h2>
                </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <img :src="empresaImage" alt="">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
               <p> 
                A Família Funada iniciou sua história no Brasil em 1931, quando Mampei e Kimi Funada deixaram o Japão com os filhos para o começo de uma história de sucesso.
                Foi em 15 de Setembro de 1947 que a Família Funada deu uma passo importante na construção do que seria um dos maiores empreendimentos da história da família e que mudaria o contexto socioeconômico de Presidente Prudente.
                A princípio, a indústria familiar era conhecida como “Funada e Filhos”, que produzia diversos tipos de bebidas, como: Guaraná, Soda Limonada, Água Tônica,  Xaropes, Conhaque, Aguardente, Quinado, Raiz Amarga e Vinagre.
                </p>
                <p>
                Entre as décadas de 50 e 60 iniciaram-se as mudanças, o empreendimento passou a receber o nome: “Indústria e Comércio de Bebidas Funada Ltda”. 
                </p>
                <p>
                Este período foi marcado principalmente pela aquisição de modernos aparelhos, que permitiram a ampliação da produção e a especialização na fabricação de refrigerantes.
                </p>
                <p>
                Em 2006, com a alta demanda de produtos Funada consumidos dentro do estado do Mato Grosso do Sul, viabilizou-se a construção de uma filial na Capital do estado.
                </p>
                <p>
                Em todos esses anos, a Bebidas Funada priorizou a qualidade para ter a confiança dos consumidores, buscou aprimorar os sabores dos produtos, os quais conquistaram todo o público, de todas as idades, principalmente a tradicional TUBAINA, aquela que fez com que todo mundo guardasse uma lembrança carinhosa da marca. Hoje a TUBAINA FUNADA é o carro chefe da empresa, porém, os sabores como: Guaraná, Laranja Mican, Limão, Uva... etc, também conquistaram seu espaço por seus deliciosos sabores. Sem contar a Linha Zero, que veio para os adeptos ao bom sabor com baixas calorias.
                </p>
                <p>
                Através do programa “PESQUISA E DESENVOLVIMENTO”, a Funada realiza uma busca contínua de novas tendências e tecnologias, para que os resultados sejam produtos de altíssima qualidade que acompanhem os anseios do mercado. 
                Hoje, além do refrigerantes, produzimos Energético, Suco, Água mineral e Água de Coco.
                </p>
                <p>
                Como retorno atuamos hoje em 6 estados e 4 países (Paraguai, Bolívia, Portugal e Japão).
                </p>
                <p>
                O amor pelo que fazemos nos faz completar 71 anos de fundação. Graças a dedicação de todos os nossos colaboradores e a fidelidade e carinho que os nossos consumidores tem por nós. 
                </p>
                <p>
                A palavra GRATIDÃO define 7 décadas de sucesso.
                </p>
                <p>
                Nosso muito OBRIGADO,  
                Indústria e Comercio de Bebidas Funada Ltda.
                </p>

                <div role="tablist">
                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion1 variant="info">Processo de Produção</b-btn>
                        </b-card-header>
                        <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <p class="card-text">
                                    “Fazer os Refrigerantes Funada é mais que produzir simplesmente uma bebida. É produzir alegrias. É fazer parte de momentos de satisfação”. A empresa dedica esforços diários na linha de produção das bebidas. São, em média, 165 mil litros por dia, somando-se Presidente Prudente e Campo Grande.
                                </p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion2 variant="info">Qualidade Total</b-btn>
                        </b-card-header>
                        <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                            <p class="card-text">
                                {{ text }}
                            </p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion3 variant="info">Frota</b-btn>
                        </b-card-header>
                        <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                            <p class="card-text">
                                {{ text }}
                            </p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      empresaImage: require("../assets/empresa.png"),
      empresa: true,
      empresaChamada: true,
      text:
        "Nulla vel quam nisl. Vivamus pretium dictum mi, a imperdiet lectus fermentum sed. Proin in sodales urna. Nullam luctus placerat enim, et consequat massa tincidunt eu. Sed fermentum risus sed ultrices ullamcorper. Vivamus ut lectus volutpat enim faucibus pharetra. Suspendisse semper lacus felis, nec ullamcorper diam imperdiet et. Integer condimentum orci vitae arcu elementum, id vehicula dolor dapibus."
    }
  }
}
</script>

<style scoped>
.empresa {
  padding-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 50px;
}

.empresa-image {
  height: 100%;
}

.empresa-chamada {
  padding-bottom: 30px;
}

.empresa img {
  width: 100%;
  padding: 8% 8% 8% 0%;
  /* position: absolute; */
  margin-top: 10%;
}

.empresa h2 {
  font-family: "Bambino";
  font-style: normal;
  font-size: 15pt;
  text-transform: uppercase;
}

.empresa h3 {
  font-family: "Bambino";
  font-style: normal;
  font-size: 10pt;
  text-transform: uppercase;
  font-weight: 300;
}

.empresa p {
  font-family: "Bambino";
  font-style: normal;
  font-size: 9pt;
  /* text-transform: uppercase; */
  font-weight: 400;
  text-align: justify;
}

.btn-info {
  color: #000;
  background-color: transparent;
  border-color: #000000;
}

.btn-info:focus,
:active {
  color: #000;
  background-color: transparent;
  border-color: #000000;
}

.btn {
  border-radius: 0px;
  font-family: "Bambino";
  text-transform: uppercase;
  font-weight: 400;
  text-align: left;
}

.card-header {
  border-bottom: 0px solid rgba(0, 0, 0, 0);
}

.btn-info:not(:disabled):not(.disabled):active,
.btn-info:not(:disabled):not(.disabled).active,
.show > .btn-info.dropdown-toggle {
  color: #000;
  background-color: transparent;
  border-color: transparent;
  -webkit-box-shadow: 0 0 0 0rem transparent;
  box-shadow: 0 0 0 0rem transparent;
}

.btn-info:focus,
.btn-info.focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0);
  box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0);
}

.card {
  border-radius: 0px;
}

@media only screen and (min-width: 320px) and (max-width: 1024px) {
  .empresa {
    padding-left: 20px;
    padding-right: 20px;
  }

  .empresa img {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Empresa.vue